import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { theme } from '_constants/theme';

import FontStyles from 'assets/fonts';

import GlobalStyles from './GlobalStyles';

const Theme = ({ children }) => (
  <>
    <FontStyles />
    <GlobalStyles />
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </>
);

Theme.propTypes = {
  children: PropTypes.element,
};

export default Theme;
